import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "ping",
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"4\" cy=\"4\" r=\"2\" fill=\"url(#paint0_linear_776_47)\" data-v-20d1dccb></circle><defs data-v-20d1dccb><linearGradient id=\"paint0_linear_776_47\" x1=\"-4\" y1=\"4\" x2=\"4\" y2=\"12\" gradientUnits=\"userSpaceOnUse\" data-v-20d1dccb><stop stop-color=\"#FF5E00\" data-v-20d1dccb></stop><stop offset=\"0.541068\" stop-color=\"#F54562\" data-v-20d1dccb></stop><stop offset=\"1\" stop-color=\"#C32DE1\" data-v-20d1dccb></stop></linearGradient></defs>", 2)
  ]))]))
}